import api from './api'
import { EmployeeNote, ApiResponse } from '../types'

export interface CreateNoteData {
  employeeId: string
  title: string
  content: string
  isImportant?: boolean
}

export interface UpdateNoteData {
  title?: string
  content?: string
  isImportant?: boolean
}

export const noteService = {
  async getByEmployeeId(employeeId: string): Promise<EmployeeNote[]> {
    const response = await api.get<ApiResponse<EmployeeNote[]>>(
      `/notes/employee/${employeeId}`
    )
    return response.data.data
  },

  async getById(id: string): Promise<EmployeeNote> {
    const response = await api.get<ApiResponse<EmployeeNote>>(`/notes/${id}`)
    return response.data.data
  },

  async create(data: CreateNoteData): Promise<EmployeeNote> {
    const response = await api.post<ApiResponse<EmployeeNote>>('/notes', data)
    return response.data.data
  },

  async update(id: string, data: UpdateNoteData): Promise<EmployeeNote> {
    const response = await api.put<ApiResponse<EmployeeNote>>(`/notes/${id}`, data)
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/notes/${id}`)
  },
}
